import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { citation } from 'src/app/core/translations/citation';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-content-citation',
  templateUrl: './content-citation.component.html',
  styleUrls: ['./content-citation.component.scss'],
})
export class ContentCitationComponent implements OnInit {
  isHandsetPortrait: boolean = false;

  bannerImage: any ='';
  bannerClass: any ='';
  currentLanguage: string = '';
  languageTranslations: any = citation;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {

    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;

    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {
        this.activeLanguageTranslations = this.languageTranslations[language];
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
}
